module.exports = __webpack_public_path__ + "media/phase-6-ava-complete.f30a4aa8.mp4";